document.addEventListener('click', function (event) {
  const minus = event.target.closest('[data-minus]');
  const plus = event.target.closest('[data-plus]');
  if (!minus && !plus) return;
  const quantity = event.target.closest('.quantity');
  if (!quantity) return;
  const input = quantity.querySelector('input');
  const value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
  input.value = value;
});

document.addEventListener('DOMContentLoaded', function () {
  if (new URLSearchParams(window.location.search).get('nova_product') !== 'featured-product') return;
  const template = document.querySelector('#NovaFallbackProductTemplate');
  const main = document.querySelector('#MainContent');
  if (!template || !main) return;
  main.replaceChildren(template.content.cloneNode(true));
  document.title = 'Insulated Travel Cup | Everyday Edition – NOVA';
  window.scrollTo(0, 0);
});
